import React from 'react'
import { images } from '../assets/constant'

const stats = [
  { value: '10+', label: 'Years in QA'       },
  { value: '4+',  label: 'Years in Security' },
  { value: '3+',  label: 'Years Mentoring'   },
  { value: '1+',  label: 'Years in AI/ML'   },
]

export default function About() {
  return (
    <section className="container py-24">

      <div className="mb-12 text-center">
        <p className="section-label">{"// about"}</p>
        <h2 className="text-[1.5rem] sm:text-[1.75rem] font-bold text-title mb-2 leading-snug">
          Security First, Quality Always
        </h2>
        <p className="text-sm text-muted">
          Not just testing — building systems that are secure from the ground up.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">

        {/* Left — image + terminal */}
        <div className="flex flex-col gap-4">
          <div className="rounded-2xl overflow-hidden border border-card-border shadow-sm">
            <img src={images.hackthebox} alt="Security work" className="w-full h-60 object-cover" />
          </div>

          {/* Terminal — always dark; it's a terminal */}
          <div className="rounded-2xl bg-zinc-950 border border-zinc-800 p-5">
            <div className="flex items-center gap-1.5 mb-4">
              <span className="w-3 h-3 rounded-full bg-red-500"></span>
              <span className="w-3 h-3 rounded-full bg-yellow-400"></span>
              <span className="w-3 h-3 rounded-full bg-green-500"></span>
              <span className="ml-2 font-mono text-xs text-zinc-500">terminal</span>
            </div>
            <pre className="font-mono text-xs text-zinc-300 leading-relaxed whitespace-pre-wrap">
{`$ whoami
> hhphu

$ cat roles.txt
> security_engineer, qa_lead,
> ta_mentor, ctf_player

$ echo $STATUS
> securing the future`}
            </pre>
          </div>
        </div>

        {/* Right — bio + stats */}
        <div className="flex flex-col justify-center gap-8">
          <div className="space-y-4 text-sm text-muted leading-relaxed">
            <p>
              10+ years shipping scalable test automation across web and mobile — cutting
              execution time by 65% and contributing to $4M+ in secured revenue.
            </p>
            <p>
              4+ years embedding security into engineering workflows: OWASP remediation,
              DevSecOps tooling, and GDPR/CCPA compliance across production systems.
            </p>
            <p>
              Currently studying AI/ML systems security — how models are attacked,
              evaluated, and hardened against adversarial threats.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3">
            {stats.map(({ value, label }) => (
              <div key={label} className="card p-5 text-center shadow-sm">
                <p className="text-2xl font-bold text-accent">{value}</p>
                <p className="mt-1 font-mono text-xs text-muted">{label}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  )
}
